import { sample } from 'effector';
import { createAddCashdeskModel } from 'features/add-cashdesk';
import { createBlockCashdeskModel } from 'features/block-cashdesk';
import { createDeleteCashdeskModel } from 'features/delete-cashdesk';
import { createDepositCashdeskModel } from 'features/deposit-cashdesk';
import { createEditCashdeskModel } from 'features/edit-cashdesk';
import { createUnblockCashdeskModel } from 'features/unblock-cashdesk';
import { createWithdrawCashdeskModel } from 'features/withdraw-cashdesk';
import { accountTreeModel } from 'entities/account';
import { createCashdeskRegistryModel } from 'entities/cashdesk';
import { accountPageModel } from './account-page-model';

const addCashdeskModel = createAddCashdeskModel();

const editCashdeskModel = createEditCashdeskModel();

const deleteCashdeskModel = createDeleteCashdeskModel();

const blockCashdeskModel = createBlockCashdeskModel();

const unblockCashdeskModel = createUnblockCashdeskModel();

const withdrawCashdeskModel = createWithdrawCashdeskModel();

const depositCashdeskModel = createDepositCashdeskModel();

export const cashdeskRegistryModel = createCashdeskRegistryModel({
	$accountId: accountPageModel.$accountId,
	currencies: accountTreeModel.$currencies,
	onDelete: [deleteCashdeskModel.mutation.finished.success],
	onUpdate: [
		accountPageModel.accountIdSet,
		editCashdeskModel.editCashdeskMutation.finished.success,
		deleteCashdeskModel.mutation.finished.success,
		blockCashdeskModel.mutation.finished.success,
		unblockCashdeskModel.mutation.finished.success,
		withdrawCashdeskModel.withdrawCashdeskMutation.finished.success,
		depositCashdeskModel.depositCashdeskMutation.finished.success,
		addCashdeskModel.addCashdeskMutation.finished.success,
	],
});

sample({
	clock: addCashdeskModel.getAccountsQuery.finished.success,
	source: accountPageModel.$accountId,
	filter: Boolean,
	target: addCashdeskModel.form.fields.accountId.setValue,
});

export const accountPageCashdesksModel = {
	cashdeskRegistryModel,
	editCashdeskModel,
	deleteCashdeskModel,
	blockCashdeskModel,
	unblockCashdeskModel,
	withdrawCashdeskModel,
	depositCashdeskModel,
	addCashdeskModel,
};
